import React from 'react';
import {useFormikContext} from 'formik';
import {TextField} from '@mui/material';
import Card from '@mui/material/Card';

export default function TransferEntryOne(code) {
  const {values} = useFormikContext();

  const getDisplayValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  return (
    <Card className={'box-shadow'} sx={{p: 4}}>
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Ownership'}
        value={getDisplayValue(values?.ownership)}
        disabled
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Accession No.'}
        value={getDisplayValue(values?.accession_no)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Classification'}
        value={getDisplayValue(values?.object_group)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Object Type'}
        value={getDisplayValue(values?.object_type_legacy || values?.object_type)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Object Name'}
        value={getDisplayValue(values?.object_name)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Sub Group'}
        value={getDisplayValue(values?.object_sub_group)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Materials'}
        value={getDisplayValue(values?.material)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
    </Card>
  );
}